import styled from '@emotion/styled';
import { Text } from '@blueprint/ui';
import { css } from '@emotion/react';
import { getRems } from '@blueprint/utils';
import { StyledButtonWithLoading } from '../../../ButtonWithLoading/ButtonWithLoading.styles';

const SocialSignInWrapperVariant = styled('div')(
    ({ theme: { boxShadow, spacing, colors } }) => css`
        display: flex;
        margin-bottom: ${spacing['32px']};

        ${StyledButtonWithLoading} {
            position: relative;
            color: ${colors['neutral-6']};
            border-color: ${colors['neutral-4']};

            /** fixed height for button with bigger icons, fix for Safari (Mac) **/
            height: ${getRems(44.15)};
            padding-top: 0;
            padding-bottom: 0;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                display: block;
                width: 100%;
                height: 100%;
                border-radius: inherit;
            }

            &:hover,
            &:focus {
                color: ${colors['neutral-6']};
                border-color: ${colors['neutral-4']};
                background-color: ${colors['graphic-background']};
            }

            &:hover {
                &:before {
                    box-shadow: ${boxShadow['200']};
                }
            }
        }

        ${StyledButtonWithLoading} + ${StyledButtonWithLoading} {
            margin-left: ${spacing['24px']};
        }
    `
);

const SocialSignInTextVariant = styled(Text)(
    ({ theme: { colors, spacing, type, fontSizes } }) => css`
        color: ${colors['text-body']};
        display: flex;
        flex-direction: row;
        font-size: ${fontSizes['1']};
        font-weight: ${type['bold']};
        margin-top: ${spacing['16px']};
        margin-bottom: ${spacing['spacing-5']};
        :before,
        :after {
            content: '';
            flex: auto;
            border-bottom: 1px solid ${colors['graphic-divider']};
            margin: auto;
        }
        :before {
            margin-right: ${spacing['8px']};
        }
        :after {
            margin-left: ${spacing['8px']};
        }
    `
);

export { SocialSignInTextVariant, SocialSignInWrapperVariant };
